import { useStaticQuery, graphql } from 'gatsby'
import { TrustpilotCompanyData } from '@talentinc/gatsby-source-trustpilot-widget'

type TrustPilotWidgetQuery = {
  trustpilotCompany: TrustpilotCompanyData
}

/**
 * useTrustPilot is a hook that provides TrustPilot widget data for the site.
 * Something to note is that this data is a singleton per site, so no variables
 * can be passed to it.
 *
 * If any questions come up around using this as opposed to their JS embed
 * library and terms of service, TrustPilot encourages us to cache/self host
 * their data with some conditions.
 *
 * https://support.trustpilot.com/hc/en-us/articles/202319278-Trustpilot-APIs-Service-Review-Integration-Guidelines
 */
export default function useTrustPilotTopInterview(): TrustpilotCompanyData | null {
  const data = useStaticQuery<TrustPilotWidgetQuery>(
    graphql`
      query UseTrustPilotTopInterview {
        trustpilotCompany(
          businessUnit: { displayName: { eq: "TopInterview" } }
        ) {
          businessUnit {
            stars
            trustScore
            numberOfReviews {
              total
              oneStar
              twoStars
              threeStars
              fourStars
              fiveStars
            }
          }
          starsString
          links {
            profileUrl
            evaluateUrl
            evaluateEmbedUrl
          }
        }
      }
    `
  )

  if (!data.trustpilotCompany?.links?.profileUrl) {
    return null
  }

  return data.trustpilotCompany
}
